import { connect } from 'react-redux';

import { getUpdatingFunnel } from '../../../reducers/analyticsApp';
import { addFunnelStep, changeFunnelStepPosition } from '../../../actions/funnel';
import CompoundUpdateStepContainer from '../../../components/compound/update/StepContainer';

const mapStateToProps = (state) => ({
  steps: getUpdatingFunnel(state).steps,
});

const mapDispatchToProps = {
  onAddStep: addFunnelStep,
  onChangeStepPosition: changeFunnelStepPosition,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompoundUpdateStepContainer);
